'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = require('react-router-redux');

var _reactRedux = require('react-redux');

var _configureStore = require('@bd/bdcore-data/build/configureStore');

var _configureStore2 = _interopRequireDefault(_configureStore);

var _bdcoreUtilities = require('@bd/bdcore-utilities');

var _Stacks = require('./Stacks');

var stacks = _interopRequireWildcard(_Stacks);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var store = _configureStore2.default.store,
    history = _configureStore2.default.history;


function StackLoader(props) {
  var stack = props.stack,
      providers = props.providers;

  var Routes = stacks.Local;

  if (typeof stack === 'function') {
    Routes = stack;
  } else if (stack && stacks[stack]) {
    Routes = stacks[stack];
  }

  if (process.env.REACT_APP_SERVER) {
    return _react2.default.createElement(Routes, props);
  }

  var ProvidersComponent = (Array.isArray(providers) ? providers : []).reverse().reduce(function (Acc, _ref) {
    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
        Component = _ref2[0],
        _ref2$ = _ref2[1],
        providerProps = _ref2$ === undefined ? {} : _ref2$;

    return function (_ref3) {
      var children = _ref3.children;
      return (// eslint-disable-line react/prop-types
        _react2.default.createElement(
          Component,
          providerProps,
          _react2.default.createElement(
            Acc,
            null,
            children
          )
        )
      );
    };
  }, function (_ref4) {
    var children = _ref4.children;
    return _react2.default.createElement(
      'div',
      null,
      children
    );
  });

  return _react2.default.createElement(
    _reactRedux.Provider,
    { store: store },
    _react2.default.createElement(
      _reactRouterRedux.ConnectedRouter,
      { history: history },
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_bdcoreUtilities.GlobalEventsConnector, null),
        _react2.default.createElement(
          ProvidersComponent,
          null,
          _react2.default.createElement(Routes, props)
        )
      )
    )
  );
}

StackLoader.propTypes = {
  stack: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node, _propTypes2.default.object, _propTypes2.default.func]),
  providers: _propTypes2.default.arrayOf(_propTypes2.default.array)
};

StackLoader.defaultProps = {
  stack: null,
  providers: []
};

exports.default = StackLoader;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-navigation-stacks/build/StackLoader.js
// module id = 1014
// module chunks = 0